import React from 'react';
import './App.css';
import Tab from './Tab'

function App() {

  return (
    <div>
      {/* ##### Preloader ##### */}
      <div id="preloader">
        <div className="loader" />
      </div>
      {/* ##### Header Area Start ##### */}
      <header className="header-area">
        {/* Navbar Area */}
        <div className="vcard-main-menu">
          <div className="classy-nav-container breakpoint-off">
            {/* Menu */}




            <nav role="navigation">
              <div id="menuToggle">
                <input type="checkbox" />
                <span />
                <span />
                <span />

                <ul id="menu">
                  <li className="active">
                    <a href="#about">About</a>
                  </li>
                  <li><a href="#skills">Skills</a></li>
                  <li><a href="#services">Services</a></li>
                  <li><a href="#contact">Contact</a></li>
                  <li><a target='_blank' href="https://codeinclusive.codabae.vercel.app">CodeInclusive</a></li>

                </ul>
              </div>


            </nav>

          </div>
        </div>
      </header>
      {/* ##### Header Area End ##### */}
      {/* ##### Hero Area Start ##### */}



      <div className="hero-area bg-img clearfix" style={{ backgroundImage: 'url(img/bg-img/bg.jpg)' }} id="about">
        <div className="container h-100">
          <div className="row h-100 align-items-center">
            <div className="col-12 col-sm-10 col-md-8" style={{ textAlign: 'center' }}>
              {/* Hero Content */}
              <div className="hero-content">
                <h5 className="wow fadeInUp" data-wow-delay="100ms">Hello I’m</h5>
                <h2 className="wow fadeInUp" data-wow-delay="300ms">Shalom Mathew</h2>
                <h3 className="wow fadeInUp" data-wow-delay="500ms">
                  Humanitarian &amp; Tech Nerd
                  </h3>
                {/* Contact Info */}
                <div className="contact-info mt-30 wow fadeInUp" data-wow-delay="700ms">
                  <a target="_blank" href="#"><img src="img/core-img/envelope-small.png" alt="" />
                    shalom.mat40@gmail.com</a>
                  <a target="_blank" href="#"><img src="img/core-img/phone-call-small.png" alt="" /> +234
                      080 93546 6694</a>
                  <a target="_blank" href="#"><img src="img/core-img/monitor-small.png" alt="" />
                    www.shalommathew.com</a>
                </div>
                {/* Social Info */}
                <div className="social-info mt-30 wow fadeInUp" data-wow-delay="900ms">
                  <a target="_blank" href="https://www.instagram.com/codabae/?hl=en" data-toggle="tooltip" data-placement="top" title="Instagram"><i className="fa fa-instagram" aria-hidden="true" /></a>
                  <a target="_blank" href="https://medium.com/@codabae" data-toggle="tooltip" data-placement="top" title="Medium"><i className="fa fa-medium" aria-hidden="true" /></a>
                  <a target="_blank" href="http://github.com/codabae" data-toggle="tooltip" data-placement="top" title="Git Hub"><i className="fa fa-github" aria-hidden="true" /></a>
                  <a target="_blank" href="https://www.facebook.com/codabae1" data-toggle="tooltip" data-placement="top" title="Facebook"><i className="fa fa-facebook" aria-hidden="true" /></a>
                  <a target="_blank" href="https://twitter.com/codabae" data-toggle="tooltip" data-placement="top" title="Twitter"><i className="fa fa-twitter" aria-hidden="true" /></a>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
      {/* ##### Hero Area End ##### */}
      {/* ##### About Me Area Start ##### */}
      <section className="about-me-area section-padding-100 clearfix" id="skills">
        <div className="container">





          <div className="row align-items-end">
            <div className="col-12 col-md-6">
              <div className="about-me-text wow fadeInUp" data-wow-delay="300ms">
                <h2>Passionate &amp; Productive</h2>
                <h6>
                  I believe that there is more to life than anyone can ever tell…
                  My name is Shalom Ijeoma Mathew, a young lady who is passionate about a lot of things.

                  </h6>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="about-me-text wow fadeInUp" data-wow-delay="500ms">
                <p>

                  Am passionate about Solving Problems, Touching Lives,  Technology,  Innovations, Creativity,  Adventures And Social Entrepreneurship.
<br></br>
                  Franz Kafka once said that
                  “Productivity is being able to do things that you were never able to do before.”
                  This quote has pushed me through a lot and iv achieved a lot just by being a productive person




                  </p>
              </div>
            </div>
          </div>

          <div className="book">
            <div className="page">
              <div className="page__1">
                <p className='skillText'>Skill Set</p>
              </div>
              <div className="page__2">
                <div className='lineDiv'>
                  <div className='innerLineDiv' style={{ width: '100%' }}></div>
                </div>
                <p style={{ marginTop: '1px' }}>HTML</p>


                <div className='lineDiv'>
                  <div className='innerLineDiv' style={{ width: '100%' }}></div>
                </div>
                <p style={{ marginTop: '1px' }}>CSS</p>


                <div className='lineDiv'>
                  <div className='innerLineDiv' style={{ width: '100%' }}></div>
                </div>
                <p style={{ marginTop: '1px' }}>JAVASCRIPT</p>


                <div className='lineDiv'>
                  <div className='innerLineDiv' style={{ width: '99%' }}></div>
                </div>
                <p style={{ marginTop: '1px' }}>REACT.JS</p>


                <div className='lineDiv'>
                  <div className='innerLineDiv' style={{ width: '99%' }}></div>
                </div>
                <p style={{ marginTop: '1px' }}>NODE.JS</p>


                <div className='lineDiv'>
                  <div className='innerLineDiv' style={{ width: '99%' }}></div>
                </div>
                <p style={{ marginTop: '1px' }}>GRAPH QL</p>

                <div className='lineDiv'>
                  <div className='innerLineDiv' style={{ width: '99%' }}></div>
                </div>
                <p style={{ marginTop: '1px' }}>Restful Api</p>

                <div className='lineDiv'>
                  <div className='innerLineDiv' style={{ width: '99%' }}></div>
                </div>
                <p style={{ marginTop: '1px' }}>MongoDB</p>

                <div className='lineDiv'>
                  <div className='innerLineDiv' style={{ width: '80%' }}></div>
                </div>
                <p style={{ marginTop: '1px' }}>Redis</p>

                






              </div>
            </div>
          </div>
        </div>
      </section>



      {/* ##### About Me Area End ##### */}
      {/* ##### Skilss Area Start ##### */}

      {/* ##### Skilss Area End ##### */}
      {/* ##### Services Area Start ##### */}
      <section className="services-area section-padding-100-0 clearfix" id="services">
        <div className="container">
          <div className="row">
            {/* Section Heading */}
            <div className="col-12">
              <div className="section-heading white text-center wow fadeInUp" data-wow-delay="300ms">
                <div className="line mx-auto" />
                <h2>Personal Services</h2>
              </div>
            </div>
          </div>
          <div className="row">

            <div className="col-12 col-sm-6 col-lg-4">
              <div className="single-service-area mb-100 wow fadeInUp" data-wow-delay="500ms">
                <div className="service-title d-flex align-items-end">
                  <div className="icon">
                    <img src="img/core-img/3.png" alt="" />
                  </div>
                  <h4>Software Engineer</h4>
                </div>
                <p>
                  Am a javascript fullstack developer, i use react.js for my frontend projects and node.js for backend development, am passionate bring inclusiveness to the tech ecosystem, contributing to  opensource  projects and
  Empowering ideas.

                  </p>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-4">
              <div className="single-service-area mb-100 wow fadeInUp" data-wow-delay="1100ms">
                <div className="service-title d-flex align-items-end">
                  <div className="icon">
                    <img src="img/core-img/teacher.png" alt="" />
                  </div>
                  <h4>Instructor</h4>
                </div>
                <p>
                  Am a javascript fullstack instructor, i teach how to code in different ways, i run a foundation called CodeInclusive. We empower people with coding skills.
                  </p>
              </div>
            </div>
            {/* Single Service Area */}
            <div className="col-12 col-sm-6 col-lg-4">
              <div className="single-service-area mb-100 wow fadeInUp" data-wow-delay="100ms">
                <div className="service-title d-flex align-items-end">
                  <div className="icon">
                    <img src="img/core-img/1.png" alt="" />
                  </div>
                  <h4>Volunteer and Community Builder</h4>
                </div>
                <p>
                  Am one of those individuals who always find themselves, sacrificing it all for positive causes, am a volunteer and a community builder.
                  </p>
              </div>
            </div>
            {/* Single Service Area */}
            <div className="col-12 col-sm-6 col-lg-4" style={{
              margin: '0 auto'
            }}>
              <div className="single-service-area mb-100 wow fadeInUp" data-wow-delay="300ms">
                <div className="service-title d-flex align-items-end">
                  <div className="icon">
                    <img src="img/core-img/2.png" alt="" />
                  </div>
                  <h4>Product Marketing
</h4>
                </div>
                <p>

                  I run youTube channel that teaches coding to persons with disabilities. As we grew in subscribers and views, we also created room for advertising tech related ads, we use the proceeds to support the community projects.

                  </p>
              </div>
            </div>


          </div>
        </div>
      </section>

      {/* ##### Portfolio Area End ##### */}
      {/* ##### Cool Facts Area Start ##### */}

      {/* ##### Cool Facts Area End ##### */}
      {/* ##### Testimonials Area Start ##### */}

      {/* ##### Testimonials Area End ##### */}
      {/* ##### Contact Area Start ##### */}
      <div className="container-contact100" id="contact">
        <div className="wrap-contact100">
          <form className="contact100-form validate-form">
            <span className="contact100-form-title">
              Talk To Me
              </span>
            <label className="label-input100" htmlFor="first-name">What's your name *</label>
            <div className="wrap-input100 rs1-wrap-input100 validate-input" data-validate="Type first name">
              <input id="first-name" className="input100" type="text" name="first-name" placeholder="First name" />
              <span className="focus-input100" />
            </div>
            <div className="wrap-input100 rs2-wrap-input100 validate-input" data-validate="Type last name">
              <input className="input100" type="text" name="last-name" placeholder="Last name" />
              <span className="focus-input100" />
            </div>
            <label className="label-input100" htmlFor="email">Enter your email *</label>
            <div className="wrap-input100 validate-input" data-validate="Valid email is required: ex@abc.xyz">
              <input id="email" className="input100" type="text" name="email" placeholder="Eg. example@email.com" />
              <span className="focus-input100" />
            </div>
            <label className="label-input100" htmlFor="phone">Enter phone number</label>
            <div className="wrap-input100">
              <input id="phone" className="input100" type="text" name="phone" placeholder="Eg. +234 000 000 000 00" />
              <span className="focus-input100" />
            </div>
            <label className="label-input100" htmlFor="message">Message *</label>
            <div className="wrap-input100 validate-input" data-validate="Message is required">
              <textarea id="message" className="input100" name="message" placeholder="Drop a short message" defaultValue={""} />
              <span className="focus-input100" />
            </div>
            <div className="container-contact100-form-btn">
              <button className="contact100-form-btn">
                Send Message
                </button>
            </div>
          </form>
          <div className="contact100-more flex-col-c-m" style={{ backgroundImage: 'url("img/bg-img/con.png")' }}>
            <div className="dis-flex size1 p-b-47">
              <div className="txt1 p-r-25">
                <span className="lnr lnr-phone-handset" />
              </div>
              <div className="flex-col size2">
                <span className="txt1 p-b-20">
                  Lets Talk
                  </span>
                <span className="txt3">
                  +234 080 935 466 94
                  </span>
              </div>
            </div>
            <div className="dis-flex size1 p-b-47">
              <div className="txt1 p-r-25">
                <span className="lnr lnr-envelope" />
              </div>
              <div className="flex-col size2">
                <span className="txt1 p-b-20">
                  General Support
                  </span>
                <span className="txt3">
                  shalom.mat40@gmail.com
                  </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="dropDownSelect1" />
      {/* ##### Contact Area End ##### */}
      {/* ##### Footer Area Start ##### */}
      <a target="_blank" href="#" className="bg-primary py-5 d-block">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md10">
              <h2 className="text-white">Let's Get Started</h2>
            </div>
          </div>
        </div>
      </a>
      <footer className="site-footer">
        <div className="container">
          <div className="row">
            <div className="col-md-9">
              <div className="row">
                <div className="col-md-5">
                  <h2 className="footer-heading mb-4">Purpose</h2>
                  <p>Win | Build | Send</p>
                </div>
                <div className="col-md-3 ml-auto">
                  <h2 className="footer-heading mb-4">Features</h2>
                  <ul className="list-unstyled">
                    <li><a href="#about">About Us</a></li>
                    <li><a href="#services">Services</a></li>
                    <li><a href="#contact">Contact Us</a></li>
                    <li><a href="https://codeinclusive.codabae.vercel.app/">CodeInclusive</a></li>
                  </ul>
                </div>
                <div className="col-md-3">
                  <h2 className="footer-heading mb-4">Follow Us</h2>
                  <a href="https://www.facebook.com/karismusicofficial" className="pl-0 pr-3"><span className="icon-facebook" /></a>
                  <a target="_blank" href="https://twitter.com/karismusicoffi1" className="pl-3 pr-3"><span className="icon-twitter" /></a>
                  <a href="https://www.instagram.com/karismusic_official/" className="pl-3 pr-3"><span className="icon-instagram" /></a>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <h2 className="footer-heading mb-4">Subscribe Newsletter</h2>
              <form action="#" method="post">
                <div className="input-group mb-3">
                  <input type="text" className="form-control border-secondary text-white bg-transparent" placeholder="Enter Email" aria-label="Enter Email" aria-describedby="button-addon2" />
                  <div className="input-group-append">
                    <button className="btn btn-primary text-white" type="button" id="button-addon2">
                      Send
                      </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;

